import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "./form";
import { Input, InputProps } from "./input";
import { Control, FieldValues, Path } from "react-hook-form";

interface Props<T extends FieldValues = FieldValues> extends InputProps {
  label: string;
  control: Control<T> | undefined;
  name: Path<T>;
  description?: string;
}

const MyFormField = <T extends FieldValues = FieldValues>({ label, control, name, description, ...props }: Props<T>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input {...props} {...field} />
          </FormControl>
          <FormMessage />
          {description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );
};

export default MyFormField;
